import { OTPInput, REGEXP_ONLY_DIGITS } from 'input-otp';
import type { FC } from 'react';
import { twcls } from '@utils/twcls';

interface OtpInputProps {
  value: string;
  onChange: (value: string) => void;
  onComplete?: (value: string) => void;
  length?: number;
  error?: string;
  disabled?: boolean;
  autoFocus?: boolean;
  className?: string;
  slotsClassName?: string;
  slotClassName?: string;
}

const OtpInput: FC<OtpInputProps> = ({
  value,
  onChange,
  onComplete,
  length = 4,
  error,
  disabled,
  autoFocus,
  className,
  slotsClassName,
  slotClassName
}) => (
  <div className={className}>
    <OTPInput
      maxLength={length}
      value={value}
      onChange={onChange}
      onComplete={onComplete}
      pattern={REGEXP_ONLY_DIGITS}
      inputMode='numeric'
      autoComplete='one-time-code'
      disabled={disabled}
      autoFocus={autoFocus}
      containerClassName='justify-center'
      render={({ slots }) => (
        <div className={twcls('flex justify-center gap-2', slotsClassName)}>
          {slots.map((slot, idx) => (
            <div
              key={idx}
              className={twcls(
                'relative flex items-center justify-center w-12 h-14 text-2xl bg-white border border-solid rounded-lg border-[var(--mid-grey)]',
                slotClassName,
                slot.isActive && 'border-[var(--main-font-color)]',
                error && 'border-[var(--dark-red)]'
              )}
            >
              {slot.char}
              {slot.hasFakeCaret && (
                <div className='absolute inset-0 flex items-center justify-center pointer-events-none'>
                  <div className='w-0.5 h-6 bg-black animate-pulse' />
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    />
    {error && (
      <p className='mt-2 text-sm text-center text-[var(--dark-red)]'>{error}</p>
    )}
  </div>
);

export default OtpInput;
